import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";
import swal from "sweetalert2";

const Notification = {};
const service = function (message, setting = {}) {
	const defaultSetting = {
		title: "הודעת מערכת",
		color: "",
		message: message,
		rtl: true,
		position: "topCenter",
	};
	iziToast.show(Object.assign(defaultSetting, setting));
};

Notification.install = function (Vue) {
	Vue.prototype.$notification = {
		alert (err) {
			alert(err);
		},
		warning (title = "האם אתה בטוח?", text = "", options = {}) {
			const def = {
				title: title,
				text: text,
				icon: "warning",
				confirmButtonColor: "#29b161",
				confirmButtonText: "אישור",
				showCancelButton: true,
				cancelButtonColor: "#d33",
				cancelButtonText: "ביטול",
			};

			if(document.documentElement.lang === "en"){
				def.customClass = {
					title: "ltr"
				};
			}
			return swal.fire(Object.assign(def, options));
		},
		service,
		success(title = "הפעולה בוצעה בהצלחה", text = "", options = {}){
			const def = {
				title: title,
				text: text,
				icon: "success",
				confirmButtonColor: "#ED217C",
				confirmButtonText: "אישור",
				showCancelButton: false
			};

			if(document.documentElement.lang === "en"){
				def.customClass = {
					title: "ltr"
				};
			}
			return swal.fire(Object.assign(def, options));
		},
		error(title = "חלה שגיאה", text = "", options = {}){
			const def = {
				title: title,
				text: text,
				icon: "error",
				confirmButtonColor: "#ED217C",
				confirmButtonText: "אישור",
			};

			if(document.documentElement.lang === "en"){
				def.customClass = {
					title: "ltr"
				};
			}
			return swal.fire(Object.assign(def, options));
		},
		question(title = "האם אתם בטוחים?", text = "", options = {}){
			const def = {
				title: title,
				text: text,
				icon: "question",
				confirmButtonColor: "#ED217C",
				confirmButtonText: "כן",
				showCloseButton: true,
				showDenyButton: true,
				denyButtonText: "לא"
			};

			if(document.documentElement.lang === "en"){
				def.customClass = {
					title: "ltr"
				};
			}
			return swal.fire(Object.assign(def, options));
		},
	};
};
export default Notification;
